module.exports = __webpack_public_path__ + "img/icon-hint.724c591f.svg";